import React, { createContext, useContext, useState } from 'react';
import AchievementModal from '../components/AchievementModal/AchievementModal';
import useAchievements from '../hooks/useAchievements';

const AchievementContext = createContext();

export const useAchievement = () => {
  const context = useContext(AchievementContext);
  if (!context) {
    throw new Error('useAchievement must be used within an AchievementProvider');
  }
  return context;
};

export const AchievementProvider = ({ children }) => {
  const [currentAchievement, setCurrentAchievement] = useState(null);
  const { achievements, loading, error, initializeAchievements, fetchAchievements } =
    useAchievements(localStorage.getItem('userID'));

  const showAchievement = (achievement) => {
    setCurrentAchievement(achievement);
  };

  const handleClose = () => {
    setCurrentAchievement(null);
  };

  const handleComplete = (achievementId) => {
    // Refresh achievements list after the achievement is marked as complete
    console.log('Fetching achievements after completion');
    fetchAchievements();
    console.log('Achievement completed:', achievementId);
  };

  return (
    <AchievementContext.Provider
      value={{
        showAchievement,
        achievements,
        loading,
        error,
        initializeAchievements,
        fetchAchievements,
      }}
    >
      {children}
      <AchievementModal
        achievement={currentAchievement}
        onClose={handleClose}
        onComplete={handleComplete}
      />
    </AchievementContext.Provider>
  );
};

export default AchievementContext;
